export default __webpack_public_path__ + "static/media/language.b70b3a21.svg";